<template>
  <div class="container-fluid">
    <div class="container p-0 card_background_effect">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-0">
          <div class="login-form d-flex">
              <form class="sign-in-sign-up-form w-100"
                  ref="form"
                  v-if="companyInfo"
                  :data-url="addUrl"
                  method="post"
                  :class="{ 'loading-opacity': preloader && active !== maxStep }">
              <div class="text-center mb-4">
                <div v-if="companyInfo.logo" class="mb-2">
                  <img :src="companyInfo.logo" alt="Company Logo" class="img-fluid logo" style="max-height: 60px;"/>
                </div>
                <h5 class="fw-bold mb-1" v-if="companyInfo.company_name">{{ companyInfo.company_name }}</h5>

                <p class="mb-1" v-if="companyInfo.address || companyInfo.address_line_1">
                  {{ companyInfo.address || [companyInfo.address_line_1, companyInfo.address_line_2, companyInfo.city, companyInfo.postal_code, companyInfo.country].filter(Boolean).join(', ') }}
                </p>

                <p class="mb-2 small">
                  <span v-if="companyInfo.company_email"><strong>Email:</strong> {{ companyInfo.company_email }}</span>
                  <span v-if="companyInfo.company_phone">
                    <span v-if="companyInfo.company_email"> | </span>
                    <strong>Phone:</strong> {{ companyInfo.company_phone }}
                  </span>
                                <span v-if="companyInfo.comapny_number">
                    <span v-if="companyInfo.company_email || companyInfo.company_phone"> | </span>
                    <strong>Company No:</strong> {{ companyInfo.comapny_number }}
                  </span>
                </p>

                <h6 class="fw-bold text-uppercase mt-3">Job Application Form</h6>
              </div>



              <div class="row" v-if="!showCompletedStatus">
                <div class="col-sm-1 col-md-2"
                     v-if="isMobile === 'vertical'">
                  <div style="height: auto">
                    <el-steps direction="vertical"
                              :active="active"  @change="handleStepChange" :space="100"
                              :align-center="true" clickable>
                      <el-step title="Basic Information"
                              />
                      <el-step title="Bank A/C Details"
                               />
                      <el-step title="Addresses"
                               />
                      <el-step title="Trainings"
                               />
                      <el-step title="Previous History"
                               />
                      <el-step title="SIA Questionnaire"
                              />
                      <el-step title="Upload Documents"
                              />
                      <el-step title="GDPR Notice"
                              />
                    </el-steps>
                  </div>
                </div>
                <div class="col-md-12 scroll-container"
                     v-if="isMobile === 'horizontal'">
                  <div class="scroll-content">
                    <div style="height: auto">
                      <el-steps direction="horizontal"  @change="handleStepChange"
                                :active="active">
                        <el-step title="Basic Information"
                                 @click.native="e => stepClick(e, 0)"/>
                        <el-step title="Bank A/C Details"
                                 @click.native="e => stepClick(e, 1)"/>
                        <el-step title="Addresses"
                                 @click.native="e => stepClick(e, 2)"/>
                        <el-step title="Trainings"
                                 @click.native="e => stepClick(e, 3)"/>
                        <el-step title="Employment History"
                                 @click.native="e => stepClick(e, 4)"/>
                        <el-step title="SIA Questionnaire"
                                 @click.native="e => stepClick(e, 5)"/>
                        <el-step title="Upload Documents"
                                 @click.native="e => stepClick(e, 6)"/>
                        <el-step title="GDPR Notice"
                                 @click.native="e => stepClick(e, 7)"/>
                      </el-steps>
                    </div>
                  </div>
                </div>
                <div :class=" isMobile == 'vertical' ? 'col-sm-11 col-md-10' : 'col-md-12'">
                  <el-form v-if="active === 0">
                    <basic-info
                        :basic_info="basicInfo"
                        :yesOrNoList="yesOrNoList"
                        :isAdmin="false"
                        :restrict-validation="isRestrictedForm"
                        :validation-default="validationDefault"
                        :onSaveBtn="saveBtnHandler"
                        ref="basicInfo"
                        @update:licenses="val => basicInfo.licenses = val"
                    />

                  </el-form>
                  <el-form v-if="active === 1">
                    <payroll-info :payroll_info="payrollInfo"
                                  ref="payrollInfo"
                                  :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === 2">
                    <address-info :address_Info="addressInfo" :dateFormatter="dateFormatter"
                                  :isAdmin="false"
                                  :emailAddress="basicInfo.email"
                                  :onSaveBtn="saveBtnHandler"
                                  :restrict-validation="isRestrictedForm ? !!validationDefault.addressHistory : true"
                                  ref="addressInfo"
                    />
                  </el-form>
                  <el-form v-if="active === 3">
                    <training-info :yesOrNoList="yesOrNoList"
                                   :training_info="trainingInfo"
                                   :dateFormatter="dateFormatter"
                                   :emailAddress="basicInfo.email"
                                   :onSaveBtn="saveBtnHandler"
                                   :isAdmin="false"
                                   ref="trainingInfo"
                    />
                  </el-form>
                  <el-form v-if="active === 4">
                    <candidate-history :candidate_history_info="candidateHistoryInfo"
                                       :emailAddress="basicInfo.email"
                                       :dateFormatter="dateFormatter"
                                       :onSaveBtn="saveBtnHandler"
                                       :isAdmin="false"
                                       :restrict-validation="isRestrictedForm ? !!validationDefault.employmentHistory : true"
                                       ref="candidateHistory"
                    />
                  </el-form>
                  <el-form v-if="active === 5">
                    <sia-info :sia_Info="siaInfo" :isAdmin="false" ref="siaStep"/>
                  </el-form>
                  <el-form v-if="active === 6">
                    <uploaded-documents-info    ref="applicantFiles" :emailAddress="basicInfo.email" :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === maxStep">
                    <gdpr-notice-info :gdpr_info="gdprInfo" :companyInfo="companyInfo" :onSaveBtn="saveBtnHandler" ref="gdprInfo" :isAdmin="false"/>
                  </el-form>
<!--                  <el-form >-->
<!--                    <policy-declaration-info :policy_declaration="policyDeclarationInfo"-->
<!--                                             :yesOrNoList="yesOrNoList"-->
<!--                                             :isAdmin="false"/>-->
<!--                  </el-form>-->
                </div>
              </div>
              <template v-if="showCompletedStatus">
                <div class="application-success-container p-4 p-md-5 mt-4">
                  <div class="text-center mb-5">
                    <div class="success-checkmark-wrapper mb-4">
                      <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                      </div>
                    </div>
                    <h2 class="display-5 fw-bold text-success mb-2 animate-up">Success!</h2>
                    <h4 class="fw-bold mb-3 animate-up delay-1">Your Application is Received.</h4>
                  </div>

                  <div class="message-box p-4 rounded-lg bg-light border-0 mb-5 animate-up delay-3">
                    <p class="mb-0 text-center lead-sm">
                      Thank you for your interest in <strong>{{ companyInfo.company_name || configData.company_name || 'our company' }}</strong>. 
                      Your application has been successfully submitted and will be reviewed by our team shortly. 
                      We appreciate the time you took to apply and will be in touch if your qualifications match our requirements.
                    </p>
                  </div>

                  <div class="next-steps-section animate-up delay-4">
                    <h5 class="fw-bold border-bottom pb-3 mb-4 text-uppercase tracking-wider small">What happens next?</h5>
                    
                    <div class="next-step-item d-flex align-items-start mb-4">
                      <div class="step-icon-bg bg-soft-success mr-3">
                        <i class="el-icon-document text-success"></i>
                      </div>
                      <div>
                        <h6 class="fw-bold mb-1">Application Review</h6>
                        <p class="text-muted small mb-0">Our team will carefully review your details and experience.</p>
                      </div>
                    </div>

                    <div class="next-step-item d-flex align-items-start mb-4">
                      <div class="step-icon-bg bg-soft-primary mr-3">
                        <i class="el-icon-user text-primary"></i>
                      </div>
                      <div>
                        <h6 class="fw-bold mb-1">Interview Process</h6>
                        <p class="text-muted small mb-0">Qualified candidates will be invited for an interview to discuss the role further.</p>
                      </div>
                    </div>

                    <div class="next-step-item d-flex align-items-start">
                      <div class="step-icon-bg bg-soft-warning mr-3">
                        <i class="el-icon-finished text-warning"></i>
                      </div>
                      <div>
                        <h6 class="fw-bold mb-1">Final Decision</h6>
                        <p class="text-muted small mb-0">We will notify all applicants of the outcome, regardless of the result.</p>
                      </div>
                    </div>
                  </div>

                  <div class="text-center mt-5 pt-4 animate-up delay-5">
                    <p class="text-secondary small">You can now safely close this window.</p>
                  </div>
                </div>
              </template>

              <div v-if="missingRanges && missingRanges.length" class="alert alert-warning">
                <strong>Incomplete history:</strong>
                <ul>
                  <li v-for="range in missingRanges" :key="missing_from">
                    <span v-if="range.missing_from">
                      Missing from {{ range.missing_from }} to {{ range.missing_to }}
                    </span>

                  </li>
                </ul>
              </div>
              <div v-if="missingDocuments && missingDocuments.length" class="alert alert-warning">
                <strong>Document Required:</strong>
                <ul>
                  <li v-for="document in missingDocuments" :key="document">
                    Missing Documents: {{ document }}
                  </li>
                </ul>
              </div>
              <div class="form-row mt-5 d-flex align-items-center position-sticky" v-if="!showCompletedStatus">
                <div class="p-2">
                  <el-button class="btn btn-primary el-button--default"
                             @click="previous"

                             v-if="this.active > 0">
                    Previous
                  </el-button>
                </div>
                <div class="p-2">
                <el-button class="btn btn-primary el-button--default"
                           @click="next"

                           v-if="this.active < maxStep">
                  Next
                </el-button>
              </div>
                <div class="p-2" v-if="this.active >= 7">
                  <el-button class="btn btn-primary el-button--default"
                             @click="saveBtnHandler(false)">
                    {{ this.active < maxStep ? 'Save' : 'Submit' }}
                  </el-button>
                </div>

              </div>
              <div class="form-row">
                <div class="col-12">
                  <p class="text-center">
                    {{ $t("copyright_text") + configData.company_name }}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

        <app-modal v-if="is_consent_modal"
                   modal-id="consent-modal"
                   modal-alignment="top"
                   modal-size="medium"
                   @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">Policy and Declaration</h5>
          </template>
          <template slot="body">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <policy-declaration-info :policy_declaration="policyDeclarationInfo" :companyInfo="companyInfo"
                                         :yesOrNoList="yesOrNoList"
                                         :isAdmin="false"/>
              </div>
            </div>
          </template>
          <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="closeModal">
              {{ $t("close") }}
            </button>
            <button
                type="button"
                class="btn btn-secondary mr-2"
                @click.prevent="acceptAll">
              {{ $t("Accept & Continue") }}
            </button>
          </template>
        </app-modal>

    </div>
  </div>
</template>

<script>

import {SCREENING_USER_REGISTRATION} from '../../../../../../js/app/Config/ScreeningAppUrl';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
import {AuthMixin} from "../../Auth/Mixins/AuthMixin";
import moment from "moment";
import {_yesOrNoList} from '@Views/Screening/utility/constant';
import {dateFormatter, checkPolicyDeclaration} from '@Views/Screening/utility/common';
import {Candidate, File} from "@Views/Screening/utility/apiAgent";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import * as actions from "@/app/Config/ApiUrl";
import AppLibrary from "@/app/Helpers/AppLibrary";

export default {
  name: "CandidateRegistration",
  extends: AppLibrary,
  mixins: [FormMixin, AuthMixin],
  props: {
    companyInfo: {
      type: Object,
      default: () => ({})
    },
    applicant: {
      type: Object,
      default: () => ({})
    },
    configData: {
      type: Object,
      default: () => ({})
    },
    validationDefault: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    $("._remove_class").removeClass("el-button");
    this.getApplicantDetails();
    $("body").click(function () {
    });
  },
  created() {
    this.setPolicyDeclarationFields();
    this.is_consent_modal = true;
    this.addUrl = window.location.pathname;

    // Set isRestrictedForm based on validationDefault
    if (this.validationDefault && Object.keys(this.validationDefault).length > 0) {
      this.isRestrictedForm = true;
    }

    // 🔹 Listen for document uploads to update local file list and validation
    this.$hub.$on('document-uploaded', (newFile) => {
      if (!this.basicInfo.files) {
        this.$set(this.basicInfo, 'files', []);
      }
      this.basicInfo.files.push(newFile);
      
      // Update missing documents list immediately
      if (this.missingDocuments && this.missingDocuments.length > 0) {
          this.missingDocuments = this.missingDocuments.filter(type => type !== newFile.type);
      }
    });

    // 🔹 Listen for document deletions
    this.$hub.$on('document-deleted', (deletedFile) => {
      if (this.basicInfo.files) {
        this.basicInfo.files = this.basicInfo.files.filter(f => f.id !== deletedFile.id);
      }

      const deletedType = `${deletedFile?.type || ''}`.toLowerCase();
      if (deletedType === 'sialicense' && Array.isArray(this.basicInfo.licenses)) {
        this.basicInfo.licenses = this.basicInfo.licenses.map((license) => {
          if(deletedFile?.id && license.license_id === deletedFile.id){
            license.license_id = null;
            license.license_name = null;
            license.license_path = null;
            license.licensePreview = null;
            license.pending_license_document = null;
          }
          return license;
        });
      }
    });
  },
  data() {
    return {
      isRestrictedForm: false,
      showCompletedStatus: false,
      is_consent_modal: false,
      basicInfo: {},
      payrollInfo: {},
      addressInfo: [],
      trainingInfo: [],
      candidateHistoryInfo: [],
      siaInfo: [],
      policyDeclarationInfo: {},
      gdprInfo: {},
      nextButton: false,
      active: 0,
      addUrl: SCREENING_USER_REGISTRATION,
      preloader: false,
      registrationForm: {},
      activeIdCollection: [],
      yesOrNoList: _yesOrNoList,
      emailAddress: '',
      maxStep: 7,
      shouldAdvanceStep: false, // <— added flag
      missingRanges: [],
      missingDocuments: [],
      allValidated: {
        sia: false,
        address: false,
        history: false,
        files: false,
      }

    };
  },
  watch: {
    showCompletedStatus(val) {
      if (val && window.confetti) {
        this.launchConfetti();
      }
    }
  },
  methods: {
    launchConfetti() {
      const duration = 5 * 1000;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

      const randomInRange = (min, max) => Math.random() * (max - min) + min;

      const interval = setInterval(function() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
      }, 250);
    },
    dateFormatter,
    checkPolicyDeclaration,
    async handleStepChange(newStepIndex) {
      if (newStepIndex === this.active) return;
      const isValidated = this.validator();
      const validBasicInfo = this.isValidForm();

      if (!isValidated || !validBasicInfo) {
        this.fieldStatus.isSubmit = true;
        this.$toastr.e("Please fill in the required fields.");
        return;
      }

      if (this.active === 5 && this.$refs.siaStep) {
        try {
          await this.$refs.siaStep.validateForm();
        } catch {
          return; // Block step change on failure
        }
      }

      this.activeIdCollection.push(newStepIndex);
      this.active = newStepIndex;
    },

    validator() {
      if (this.active === 2) {
        return this.addressHistoryValidation();
      }
      if (this.active === 4) {
        return this.candidateHistoryValidation();
      }
      if (this.active === 6) {
        return this.documentsValidation();
      }
      return true;
    },
    addressHistoryValidation() {
      const comp = this.$refs.addressInfo;
      // If not restricted, skip blocking validation entirely
      if (comp && (comp.restrictValidation === false || !this.isRestrictedForm)) {
        return true;
      }
      const hasAddresses = Array.isArray(this.addressInfo) && this.addressInfo.length > 0;
      if (!hasAddresses) return false;
      const hasGaps = comp && Array.isArray(comp.gaps) && comp.gaps.length > 0;
      const notCoveredFiveYears = comp && comp.isFiveYearsCovered === false;
      if (hasGaps || notCoveredFiveYears) {
        this.$toastr.e('Missing address history. Please fill the gaps.');
        return false;
      }
      return true;
    },
    candidateHistoryValidation() {
      // Respect restricted mode only
      if (!this.isRestrictedForm || (this.validationDefault && !this.validationDefault.employmentHistory)) {
        return true;
      }
      const hasHistory = Array.isArray(this.candidateHistoryInfo) && this.candidateHistoryInfo.length > 0;
      if (!hasHistory) return false;
      const comp = this.$refs.candidateHistory;
      const hasGaps = comp && Array.isArray(comp.historyGaps) && comp.historyGaps.length > 0;
      if (hasGaps) {
        this.$toastr.e('Missing previous history. Please fill the gaps.');
        return false;
      }
      return true;
    },
    documentsValidation() {
      if (!this.isRestrictedForm || (this.validationDefault && !this.validationDefault.documents)) {
        return true;
      }
      // Frontend check if we have files loaded
      if (this.basicInfo && Array.isArray(this.basicInfo.files)) {
        const uploadedTypes = this.basicInfo.files.map(f => f.type);
        const requiredTypes = [
          'passport',
          'bankStatement',
          'utilityBill_1',
          'utilityBill_2',
          'siaLicense',
        ];
        if (this.basicInfo.is_driving_license === 'yes' || this.basicInfo.is_driving_license === true || this.basicInfo.is_driving_license === 1) {
            requiredTypes.push('driving_license');
        }

        const missing = requiredTypes.filter(type => !uploadedTypes.includes(type));
        if (missing.length > 0) {
          this.missingDocuments = missing;
          this.$toastr.e('Please upload all required documents.');
          return false;
        }
      }
      
      // If we already have missing documents from server, block
      if (this.missingDocuments && this.missingDocuments.length > 0) {
        this.$toastr.e('Please upload all required documents.');
        return false;
      }
      return true;
    },
    previous() {
      this.fieldStatus.isSubmit = false;
      if (this.active-- < this.maxStep) this.active = this.active--;
      if(this.active < 8){
        this.showCompletedStatus = false
      }
    },
    async stepClick(_, id) {
      this.fieldStatus.isSubmit = false;
      const isValidated = this.validator();
      const validBasicInfo = this.isValidForm();

      // Stop if basic or general validation fails
      if (!isValidated || !validBasicInfo) {
        this.fieldStatus.isSubmit = true;
        this.$toastr.e("Please fill in the required fields.");
        return;
      }

      // Extra validation for SIA step (step 5)
      if (this.active === 5 && this.$refs.siaStep) {
        try {
          await this.$refs.siaStep.validateForm();
        } catch {
          return; // Custom validation failed
        }
      }

      // All validation passed — move to the selected step
      this.activeIdCollection.push(id);
      this.active = id;
    },


    getEmailFromQueryString() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      return params.email ?? false;

    },
    getApplicantDetails() {
      let ifEmailInQueryString = this.getEmailFromQueryString();
      if (this.applicant && this.applicant.email) {
        ifEmailInQueryString = this.applicant.email;
      }
      let _email = ifEmailInQueryString ?? localStorage.getItem('candidate-email');
      this.preloader = true;
      Candidate.getCandidateByEmail(_email)
          .then(({data}) => {
            if (data?.applicant && Object.values(data?.applicant).length > 0) {
              this.setApiResponseIntoBasicInfoProps(data.applicant, data.applicant.files);
              this.setApiResponseIntoPayrollProps(data.applicant?.applicant_payroll);
              this.setApiResponseIntoPolicyDeclrationProps(data.applicant?.applicant_policy_declaration);
              this.setApiResponseIntoGdprProps(data.applicant?.applicant_gdpr_detail);
              this.setApiResponseIntoTrainingProps(data.applicant?.applicant_training);
              this.setApiResponseIntoAddressProps(data.applicant?.applicant_address);
              this.setApiResponseIntoSIAProps(data.applicant?.applicant_sia_detail);
              this.setApiResponseIntoPreviousHistoryProps({
                employment: data.applicant?.applicant_employment,
                education: data.applicant?.applicant_education,
                selfEmployment: data.applicant?.applicant_self_employment,
                unEmployment: data.applicant?.applicant_unemployment,
                applicantEmail: data.applicant?.email,
              });
            } else if(_email) {
              this.$set(this.basicInfo, 'email', _email);
              // window.location.reload();
            }else{
              localStorage.removeItem('candidate-email');
            }
          })
          .finally(() => {
            this.preloader = false;
          });
    },
    setApiResponseIntoBasicInfoProps(applicant, files = null) {
      this.$set(this.basicInfo, 'employee_picture_path', null);
      this.$set(this.basicInfo, 'employee_picture_name', null);
      this.$set(this.basicInfo, 'pending_profile_pic', null);
      this.$set(this.basicInfo, 'employeeImagePreview', null);
      this.$set(this.basicInfo, 'passport_path', null);
      this.$set(this.basicInfo, 'passport_name', null);
      this.$set(this.basicInfo, 'pending_passport', null);
      this.$set(this.basicInfo, 'passportPreview', null);
      this.$set(this.basicInfo, 'driving_license_path', null);
      this.$set(this.basicInfo, 'driving_license_name', null);
      this.$set(this.basicInfo, 'pending_driving_license', null);
      this.$set(this.basicInfo, 'drivingLicensePreview', null);
      this.$set(this.basicInfo, 'driving_license_document', null);
      this.$set(this.basicInfo, 'passport', null);
      this.$set(this.basicInfo, 'employee_picture', null);

      this.$set(this.basicInfo, 'files', files);

      if (files && Array.isArray(files)) {
        const profilePic = files.filter(f => f.type === 'profile_pic').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);
        
        if (profilePic) {
          this.$set(this.basicInfo, 'employee_picture_path', profilePic.file_path);
          this.$set(this.basicInfo, 'employee_picture_name', profilePic.file_name);
          this.$set(this.basicInfo, 'employee_picture_id', profilePic.id);
        }

        const passportFile = files.filter(f => f.type === 'passport').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (passportFile) {
          this.$set(this.basicInfo, 'passport_path', passportFile.file_path);
          this.$set(this.basicInfo, 'passport_name', passportFile.file_name);
          this.$set(this.basicInfo, 'passport_id', passportFile.id);
        }

        const drivingLicenseFile = files.filter(f => f.type === 'driving_license').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (drivingLicenseFile) {
          this.$set(this.basicInfo, 'driving_license_path', drivingLicenseFile.file_path);
          this.$set(this.basicInfo, 'driving_license_name', drivingLicenseFile.file_name);
          this.$set(this.basicInfo, 'driving_license_id', drivingLicenseFile.id);
        }
      }

      this.$set(this.basicInfo, 'position_applied', applicant.position_applied);
      this.$set(this.basicInfo, 'full_name', applicant.full_name);
      this.$set(this.basicInfo, 'forename', applicant.forename);
      this.$set(this.basicInfo, 'middle_name', applicant.middle_name);
      this.$set(this.basicInfo, 'surname', applicant.surname);
      this.$set(this.basicInfo, 'n_i_number', applicant.n_i_number);
      this.$set(this.basicInfo, 'gender', applicant.gender);
      this.$set(this.basicInfo, 'date_of_birth', applicant.date_of_birth);
      this.$set(this.basicInfo, 'title', applicant.title);
      this.$set(this.basicInfo, 'country_of_birth', applicant.country_of_birth);
      this.$set(this.basicInfo, 'town_of_birth', applicant.town_of_birth);
      this.$set(this.basicInfo, 'photo_id_match', applicant.photo_id_match);
      this.$set(this.basicInfo, 'nationality', applicant.nationality);
      this.$set(this.basicInfo, 'edbs_number', applicant.edbs_number);
      this.$set(this.basicInfo, 'contact_number', applicant.contact_number ?? '');
      this.$set(this.basicInfo, 'alternative_contact_no', applicant.alternative_contact_no ?? '');
      this.$set(this.basicInfo, 'email', applicant.email);
      this.$set(this.basicInfo, 'additional_email', applicant.additional_email);
      this.$set(this.basicInfo, 'report_email', applicant.report_email || 'primary');
      this.$set(this.basicInfo, 'relationship', applicant.relationship);
      this.$set(this.basicInfo, 'next_of_kin', applicant.next_of_kin);
      this.$set(this.basicInfo, 'next_of_kin_contact_no', applicant.next_of_kin_contact_no ?? '');
      this.$set(this.basicInfo, 'is_sia_required', applicant.is_sia_required === 1 ? true : false);
      this.$set(this.basicInfo, 'sia_license_number', applicant.sia_license_number);
      this.$set(this.basicInfo, 'sia_license_type', applicant.sia_license_type);
      this.$set(this.basicInfo, 'sia_license_expiry', applicant.sia_license_expiry);
      this.$set(this.basicInfo, 'is_additional_license', applicant.is_additional_license === 1 ? true : false);
      this.$set(this.basicInfo, 'additional_sia_license_number', applicant.additional_sia_license_number);
      this.$set(this.basicInfo, 'additional_sia_license_type', applicant.additional_sia_license_type);
      this.$set(this.basicInfo, 'additional_sia_license_expiry', applicant.additional_sia_license_expiry);
      this.$set(this.basicInfo, 'share_code', applicant.share_code);
      this.$set(this.basicInfo, 'share_code_start_date', applicant.share_code_start_date);
      this.$set(this.basicInfo, 'employee_picture', applicant.employee_picture);
      this.$set(this.basicInfo, 'is_visa_require_uk', applicant.is_visa_require_uk);
      this.$set(this.basicInfo, 'visa_type', applicant.visa_type);
      this.$set(this.basicInfo, 'biometric_residence_permit', applicant.biometric_residence_permit);
      this.$set(this.basicInfo, 'visa_expiry', applicant.visa_expiry);
      this.$set(this.basicInfo, 'date_of_entry_re_entry', applicant.date_of_entry_re_entry);
      this.$set(this.basicInfo, 'is_have_p45_or_p46', applicant.is_have_p45_or_p46);
      this.$set(this.basicInfo, 'copy_of_p45', applicant.copy_of_p45);
      this.$set(this.basicInfo, 'p46_detail', applicant.p46_detail);
      this.$set(this.basicInfo, 'is_other_employment', applicant.is_other_employment);
      this.$set(this.basicInfo, 'continue_other_employment', applicant.continue_other_employment);
      this.$set(this.basicInfo, 'is_leisure', applicant.is_leisure);
      this.$set(this.basicInfo, 'leisure_details', applicant.leisure_details);
      this.$set(this.basicInfo, 'is_criminal_record', applicant.is_criminal_record);
      this.$set(this.basicInfo, 'criminal_record_details', applicant.criminal_record_details);
      this.$set(this.basicInfo, 'is_bankruptcy', applicant.is_bankruptcy);
      this.$set(this.basicInfo, 'bankruptcy_details', applicant.bankruptcy_details);
      this.$set(this.basicInfo, 'is_days_shift_cant_work', applicant.is_days_shift_cant_work);
      this.$set(this.basicInfo, 'days_shift_cant_work_details', applicant.days_shift_cant_work_details);
      this.$set(this.basicInfo, 'is_holidays_commitment', applicant.is_holidays_commitment);
      this.$set(this.basicInfo, 'holidays_commitment_details', applicant.holidays_commitment_details);
      this.$set(this.basicInfo, 'is_own_vehicle', applicant.is_own_vehicle);
      this.$set(this.basicInfo, 'is_driving_license', applicant.is_driving_license);
      this.$set(this.basicInfo, 'driver_license_number', applicant.driver_license_number);
      this.$set(this.basicInfo, 'license_type', applicant.license_type);
      this.$set(this.basicInfo, 'license_issue_date', applicant.license_issue_date);
      this.$set(this.basicInfo, 'license_expiry_date', applicant.license_expiry_date);
      if (applicant.licenses && Array.isArray(applicant.licenses) && files && Array.isArray(files)) {
        const cleanedLicenses = applicant.licenses.map(license => {
          if (license.license_id) {
            const fileExists = files.some(f => f.id == license.license_id);
            if (!fileExists) {
              return {
                ...license,
                license_id: null,
                license_path: null,
                license_name: null,
                licensePreview: null,
                pending_license_document: null,
                license_document: null
              };
            }
          }
          return license;
        });
        this.$set(this.basicInfo, 'licenses', cleanedLicenses);
      } else {
        this.$set(this.basicInfo, 'licenses', applicant.licenses);
      }
    },
    setApiResponseIntoPayrollProps(payroll) {
      if (payroll && Object.values(payroll).length > 0) {
        this.$set(this.payrollInfo, 'account_name', payroll.account_name);
        this.$set(this.payrollInfo, 'account_number', payroll.account_number);
        this.$set(this.payrollInfo, 'bank_name', payroll.bank_name);
        this.$set(this.payrollInfo, 'other_information', payroll.other_information);
        this.$set(this.payrollInfo, 'sort_code', payroll.sort_code);
      }
    },
    setApiResponseIntoAddressProps(address) {
      if (address && address.length > 0) {
        this.addressInfo = address;
      }
    },
    setApiResponseIntoTrainingProps(training) {
      if (training && training.length > 0) {
        this.trainingInfo = training;
        this.$set(this.trainingInfo, 'emailAddress', this.basicInfo.email);

      }
    },
    setApiResponseIntoPreviousHistoryProps(previousHistory) {
      this.candidateHistoryInfo = [];
      const mapFiles = (item) => {
        if (item.applicant_files && Array.isArray(item.applicant_files)) {
          return { ...item, files: item.applicant_files.map(f => ({ ...f, file_name: f.file_name || f.name, file_path: f.file_path || f.path })) };
        }
        return item;
      };

      if (previousHistory.employment && previousHistory.employment.length > 0) {
        for (const employment of previousHistory.employment) {
          this.candidateHistoryInfo.push(mapFiles({...employment, type: 0}));
        }
      }
      if (previousHistory.education && previousHistory.education.length > 0) {
        for (const education of previousHistory.education) {
          this.candidateHistoryInfo.push(mapFiles({...education, type: 1}));
        }
      }
      if (previousHistory.selfEmployment && previousHistory.selfEmployment.length > 0) {
        for (const selfEmployment of previousHistory.selfEmployment) {
          this.candidateHistoryInfo.push(mapFiles({...selfEmployment, type: 2}));
        }
      }
      if (previousHistory.unEmployment && previousHistory.unEmployment.length > 0) {
        for (const unEmployment of previousHistory.unEmployment) {
          this.candidateHistoryInfo.push(mapFiles({...unEmployment, type: 3}));
        }
      }
    },
    setApiResponseIntoSIAProps(sia) {
      if (sia && sia.length > 0) {
        this.siaInfo = sia
      }
    },
    setApiResponseIntoGdprProps(gdpr) {
      if (gdpr && Object.values(gdpr).length > 0) {

        this.$set(this.gdprInfo, 'consent', gdpr.consent === 1 ? true : false);
        this.$set(this.gdprInfo, 'consent_date_time', gdpr.consent_date_time);
        this.$set(this.gdprInfo, 'special_category_data', gdpr.special_category_data === 1 ? true : false);
        this.$set(this.gdprInfo, 'signature', gdpr.signature);
        this.$set(this.gdprInfo, 'criminal', gdpr.criminal);
        this.$set(this.gdprInfo, 'financial', gdpr.financial);
        this.$set(this.gdprInfo, 'health', gdpr.health);
        this.$set(this.gdprInfo, 'diversity', gdpr.diversity);
        this.$set(this.gdprInfo, 'biometric', gdpr.biometric);
        this.$set(this.gdprInfo, 'companyInfo', this.companyInfo);
      }
    },
    setApiResponseIntoPolicyDeclrationProps(policyDeclration) {
      if (policyDeclration && Object.values(policyDeclration).length > 0) {
        this.$set(this.policyDeclarationInfo, 'applicant_screening', policyDeclration.applicant_screening === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'criminal_background_check', policyDeclration.criminal_background_check === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', policyDeclration.declaration_by_applicant === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'financial_history', policyDeclration.financial_history === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality', policyDeclration.equality === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality_details', policyDeclration.equality_details);
        this.$set(this.policyDeclarationInfo, 'working_time_directive', policyDeclration.working_time_directive);
      }
    },
    closeModal() {
      this.is_consent_modal = false;
      $("#consent-modal").modal("hide");
    },
    acceptAll() {
      this.$set(this.policyDeclarationInfo, 'applicant_screening', true);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check', true);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', true);
      this.$set(this.policyDeclarationInfo, 'financial_history', true);
      this.$set(this.policyDeclarationInfo, 'equality', true);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'yes');
      setTimeout(() => {
        this.closeModal()
      }, 1000 )

    },
    setPolicyDeclarationFields(){
      this.$set(this.policyDeclarationInfo, 'applicant_screening', false);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check',  false);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', false);
      this.$set(this.policyDeclarationInfo, 'financial_history', false);
      this.$set(this.policyDeclarationInfo, 'equality', false);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'no');
    },
    confirmSubmission(lastFormIndex) {
      if (confirm("Are you sure all the information is correct and you want to submit? You may cancel and go back to review your information." )) {
        return true; // Proceed with submission
      } else {
        this.active = 0; // Take the user back to the previous step for review
        return false;
      }
    },
    async next() {
      const isValidated = this.validator();
      const validBasicInfo = this.isValidForm();

      // ✅ Validate fields from AppInput-based components
      if (this.$refs.basicInfo !== undefined) {
        this.$refs.basicInfo.fieldStatus.isSubmit = true;
      }
      if (this.$refs.payrollInfo !== undefined) {
        this.$refs.payrollInfo.fieldStatus.isSubmit = true;
      }

      // ❌ Stop if built-in validation fails
      if (!isValidated || !validBasicInfo) {
        this.fieldStatus.isSubmit = true;
        this.$toastr.e("Please fill in the required fields.");
        return;
      }

      // ✅ File validation
      if (!this.validateFiles()) {
        return;
      }

      // ✅ Check if this step has extra validation (e.g., SIA step = step 5)
      if (this.active === 5 && this.$refs.siaStep) {
        try {
          await this.$refs.siaStep.validateForm();
        } catch {
          return; // Validation failed; don't proceed
        }
      }

      // ✅ Set this flag BEFORE triggering save
      this.shouldAdvanceStep = true;

      // 🔄 Continue with backend save; afterSuccess will advance the step
      this.saveBtnHandler(false);
    },

    validateFiles() {
      if (this.active === 0) {
        // Applicant Picture
        if (!this.basicInfo.pending_profile_pic && !this.basicInfo.employee_picture_path) {
          this.$toastr.e("Applicant Picture is required.");
          return false;
        }

        // Licenses - Always validate SIA licenses
        if (this.basicInfo.licenses && this.basicInfo.licenses.length > 0) {
          for (let i = 0; i < this.basicInfo.licenses.length; i++) {
            const license = this.basicInfo.licenses[i];
            if (!license.pending_license_document && !license.license_path) {
              this.$toastr.e(`SIA License document is required for License ${i + 1}.`);
              return false;
            }
          }
        }

        // Driving License
        if (this.basicInfo.is_driving_license === 'yes' || this.basicInfo.is_driving_license === true || this.basicInfo.is_driving_license === 1) {
          if (!this.basicInfo.pending_driving_license && !this.basicInfo.driving_license_path) {
            this.$toastr.e("Driving License document is required.");
            return false;
          }
        }

        // Right to Work
        if (this.basicInfo.is_visa_require_uk === 'no' || this.basicInfo.is_visa_require_uk === false || this.basicInfo.is_visa_require_uk === 0) {
          if (!this.basicInfo.pending_passport && !this.basicInfo.passport_path) {
            this.$toastr.e("Proof of right to work (Passport/Birth Certificate) is required.");
            return false;
          }
        }
      }

      if (this.active === 3) {
        // Training Information
        if (this.trainingInfo && this.trainingInfo.length > 0) {
          for (let i = 0; i < this.trainingInfo.length; i++) {
            const training = this.trainingInfo[i];
            if (!training.certificate_path && !training.pending_certificate) {
              this.$toastr.e(`Upload Certificate for training: ${training.title}.`);
              return false;
            }
          }
        }
      }

      // Document validation removed as per requirement

      return true;
    },



    async saveBtnHandler(final = true) {
      if (!final) {
        if (this.lastFormIndex === this.maxStep && !this.confirmSubmission()) {
          return;
        }
      }

      if (!this.checkPolicyDeclaration(this.policyDeclarationInfo)) {
        this.is_consent_modal = true;
        return;
      }

      let employment = this.candidateHistoryInfo.filter(x => x.type === 0);
      let education = this.candidateHistoryInfo.filter(x => x.type === 1);
      let selfEmployment = this.candidateHistoryInfo.filter(x => x.type === 2);
      let unEmployment = this.candidateHistoryInfo.filter(x => x.type === 3);

      if (this.basicInfo.visa_type_others)
        this.basicInfo.visa_type = this.basicInfo.visa_type_others;

      this.registrationForm = {
        applicant: this.basicInfo,
        applicantPayroll: this.payrollInfo,
        applicantAddress: this.addressInfo,
        applicantTraining: this.trainingInfo,
        applicantEmployment: employment,
        applicantEducation: education,
        applicantSelfEmployment: selfEmployment,
        applicantUnemployment: unEmployment,
        applicantSiaDetail: this.siaInfo,
        applicantGdprDetail: this.gdprInfo,
        applicantPolicyDeclaration: this.policyDeclarationInfo,
        searchAction: this.searchAction ?? [],
        currentStep: this.active,
        validationStatus: this.allValidated
      };

      // Handle pending files if they exist
      const hasPendingLicenses = this.basicInfo.licenses?.some(l => l.pending_license_document);
      if (this.basicInfo.pending_profile_pic || this.basicInfo.pending_passport || this.basicInfo.pending_driving_license || hasPendingLicenses) {
        this.beforeSubmit(); // setting preloader to true
        try {
          if (this.basicInfo.pending_profile_pic) {
            if (this.basicInfo.employee_picture_id) {
              await File.deleteDocument(this.basicInfo.employee_picture_id);
            }
            let formData = new FormData();
            formData.append('email', this.basicInfo.email);
            formData.append('type', 'profile_pic');
            formData.append('files', this.basicInfo.pending_profile_pic);
            const response = await File.uploadDocument(formData);
            const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
            if (uploadedFile && uploadedFile.file_path) {
              this.$set(this.basicInfo, 'employee_picture_path', uploadedFile.file_path);
              this.$set(this.basicInfo, 'employee_picture_id', uploadedFile.id);
              this.$set(this.basicInfo, 'employee_picture_name', uploadedFile.file_name);
            }
            this.$set(this.basicInfo, 'pending_profile_pic', null);
            this.$set(this.basicInfo, 'employeeImagePreview', null);
            this.$set(this.basicInfo, 'employee_picture', null);
          }
          if (this.basicInfo.pending_passport) {
            if (this.basicInfo.passport_id) {
              await File.deleteDocument(this.basicInfo.passport_id);
            }
            let formData = new FormData();
            formData.append('email', this.basicInfo.email);
            formData.append('type', 'passport');
            formData.append('files', this.basicInfo.pending_passport);
            const response = await File.uploadDocument(formData);
            const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
            if (uploadedFile && uploadedFile.file_path) {
              this.$set(this.basicInfo, 'passport_path', uploadedFile.file_path);
              this.$set(this.basicInfo, 'passport_id', uploadedFile.id);
              this.$set(this.basicInfo, 'passport_name', uploadedFile.file_name);
            }
            this.$set(this.basicInfo, 'pending_passport', null);
            this.$set(this.basicInfo, 'passportPreview', null);
            this.$set(this.basicInfo, 'passport', null);
          }
          if (this.basicInfo.pending_driving_license) {
            if (this.basicInfo.driving_license_id) {
              await File.deleteDocument(this.basicInfo.driving_license_id);
            }
            let formData = new FormData();
            formData.append('email', this.basicInfo.email);
            formData.append('type', 'driving_license');
            formData.append('files', this.basicInfo.pending_driving_license);
            const response = await File.uploadDocument(formData);
            const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
            if (uploadedFile && uploadedFile.file_path) {
              this.$set(this.basicInfo, 'driving_license_path', uploadedFile.file_path);
              this.$set(this.basicInfo, 'driving_license_id', uploadedFile.id);
              this.$set(this.basicInfo, 'driving_license_name', uploadedFile.file_name);
            }
            this.$set(this.basicInfo, 'pending_driving_license', null);
            this.$set(this.basicInfo, 'drivingLicensePreview', null);
            this.$set(this.basicInfo, 'driving_license_document', null);
          }

          /*if (this.basicInfo.licenses && Array.isArray(this.basicInfo.licenses)) {
            for (let i = 0; i < this.basicInfo.licenses.length; i++) {
              const license = this.basicInfo.licenses[i];
              if (license.pending_license_document) {
                if (license.license_id) {
                  await File.deleteDocument(license.license_id);
                }
                let formData = new FormData();
                formData.append('email', this.basicInfo.email);
                formData.append('type', 'siaLicense');
                formData.append('files', license.pending_license_document);
                const response = await File.uploadDocument(formData);
                const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
                if (uploadedFile && uploadedFile.file_path) {
                  this.$set(license, 'license_path', uploadedFile.file_path);
                  this.$set(license, 'license_id', uploadedFile.id);
                  this.$set(license, 'license_name', uploadedFile.file_name);
                }
                this.$set(license, 'pending_license_document', null);
                this.$set(license, 'licensePreview', null);
                this.$set(license, 'license_document', null);
              }
            }
          }*/
        } catch (error) {
          this.$toastr.e("Failed to upload some files.");
        } finally {
          this.preloader = false;
        }
      }

      this.beforeSubmit();
      this.save(this.registrationForm);
    },


    beforeSubmit() {
      this.preloader = true;
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      this.missingDocuments = res.data.missing_documents || [];
      this.missingRanges = res.data.missing_ranges || [];
      this.$emit('afterSubmitDone');

      if (this.shouldAdvanceStep) {
        if (this.active < this.maxStep) {
          this.active++;
          this.activeIdCollection.push(this.active);
          $("#_remove_class_").removeClass("el-button");
        } else {
          this.showCompletedStatus = true;
        }
      }else if (res.data.currentStep === 7){
        this.missingDocuments = [];
        this.missingRanges = [];
        this.showCompletedStatus = true;
      }
      const stepMap = {
        sia: 0,
        address: 2,
        history: 4,
        files: 6,
      };
      for (const [key, index] of Object.entries(stepMap)) {
        if (res.data.currentStep === index) {
          this.allValidated[key] = true;
        }
      }

      this.fieldStatus.isSubmit = false;

      this.shouldAdvanceStep = false; // ✅ always reset
      if (res.data.applicant) {
        this.setApiResponseIntoBasicInfoProps(res.data.applicant, res.data.applicant.files);
        this.setApiResponseIntoPreviousHistoryProps({
          employment: res.data.applicant?.applicant_employment,
          education: res.data.applicant?.applicant_education,
          selfEmployment: res.data.applicant?.applicant_self_employment,
          unEmployment: res.data.applicant?.applicant_unemployment,
          applicantEmail: res.data.applicant?.email,
        });
      }
      this.setApiResponseIntoAddressProps(res.data.applicant?.applicant_address);
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
      this.missingRanges = res.data.missing_ranges || [];

      if (this.$refs.basicInfo !== undefined) {
        this.active = 0;
      } else if (this.$refs.addressInfo !== undefined) {
        this.active = 2;
        if (Array.isArray(res.data.missing_ranges) && res.data.missing_ranges.length) {
          this.$toastr.e('Missing address history. Please fill the gaps.');
          alert('Missing address history. Please fill the gaps.');
        }
      } else if (this.$refs.candidateHistory !== undefined) {
        if (Array.isArray(res.data.missing_ranges) && res.data.missing_ranges.length) {
          this.$toastr.e('Missing previous history. Please fill the gaps.');
          alert('Missing previous history. Please fill the gaps.');
        }
      } else if (this.$refs.applicantFiles !== undefined) {
        this.active = 6; // point to the Upload Documents step
        if (res.data.missing_documents && Array.isArray(res.data.missing_documents)) {
          this.missingDocuments = res.data.missing_documents;
          const missingList = res.data.missing_documents.join(', ');
          alert("Missing documents: " + missingList);
        }
      }

      this.shouldAdvanceStep = false; // ✅ always reset
    },

    afterFinalResponse() {
      this.preloader = false;
      this.registrationForm = {};
    },




  },
  computed: {
    lastFormIndex(){
      return this.activeIdCollection.at(-1)
    },
    isMobile() {
      let width = window.innerWidth;
      let stepsDirection;
      // Set to vertical on small screens (less than 768px)
      if (width <= 768) {
        stepsDirection = 'vertical';
      } else {
        stepsDirection = 'horizontal';
      }
      return stepsDirection;
    },
    addUrl() {
      let url = window.location.href;

      // Split out the base path and query string
      let [path] = url.split('?');
      let queryString = url.includes('?') ? '?' + url.split('?')[1] : '';

      // Extract the encryptedCompanyKey from the last path segment
      let pathSegments = path.split('/');
      let encryptedCompanyKey = pathSegments[pathSegments.length - 1];

      // Return full URL with query string preserved
      return SCREENING_USER_REGISTRATION + '/' + encryptedCompanyKey + queryString;
    }

  }
}
</script>

<style scoped>
.application-success-container {
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
}

.success-checkmark-wrapper {
  display: flex;
  justify-content: center;
}

.check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #4caf50;
}

.check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}

.check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}

.check-icon::before, .check-icon::after {
  content: '';
  height: 100px;
  position: absolute;
  background: #ffffff;
  transform: rotate(-45deg);
}

.icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}

.icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}

.icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}

.icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(76, 175, 80, 0.5);
}

.icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #ffffff;
}

@keyframes icon-line-tip {
  0% { width: 0; left: 1px; top: 19px; }
  54% { width: 0; left: 1px; top: 19px; }
  70% { width: 50px; left: -8px; top: 37px; }
  84% { width: 17px; left: 21px; top: 48px; }
  100% { width: 25px; left: 14px; top: 46px; }
}

@keyframes icon-line-long {
  0% { width: 0; right: 46px; top: 54px; }
  65% { width: 0; right: 46px; top: 54px; }
  84% { width: 55px; right: 0px; top: 35px; }
  100% { width: 47px; right: 8px; top: 38px; }
}

.animate-up {
  animation: fadeInUp 0.6s ease-out forwards;
  opacity: 0;
}

.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }
.delay-3 { animation-delay: 0.6s; }
.delay-4 { animation-delay: 0.8s; }
.delay-5 { animation-delay: 1s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bg-soft-success { background-color: rgba(40, 167, 69, 0.1); }
.bg-soft-primary { background-color: rgba(0, 123, 255, 0.1); }
.bg-soft-warning { background-color: rgba(255, 193, 7, 0.1); }

.step-icon-bg {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-shrink: 0;
}

.step-icon-bg i {
  font-size: 1.2rem;
}

.tracking-wider { letter-spacing: 0.05em; }
.lead-sm { font-size: 1.05rem; line-height: 1.6; }

.success-icon {
  animation: scale-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes scale-up {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  padding-top: 15px;
  padding-bottom: 10px;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.el-step.is-horizontal .el-step__main .el-step__title {
  padding-right: 14px !important;
  cursor: pointer;
}

.el-step__title {
  font-size: 12px !important;
  line-height: 40px !important;
  color: #292f4c !important;
}

.el-step__head.is-process .el-step__icon.is-text {
  color: #292f4c !important;
  border-color: #292f4c !important;
}

.el-step__head.is-finish {
  color: #292f4c !important;
  border-color: #292f4c !important;
}
.el-step__head.is-finish .el-step__line .el-step__line-inner {
  border-color: #292f4c !important;
}

.el-step__head.is-finish .el-step__icon.is-text {
  background-color: #292f4c !important;
  color: white !important;
  border-color: #C0C4CC !important;
}
.el-step__head.is-finish .el-step__icon .el-step__icon-inner::before {
  content: '\2713';
  font-size: 16px !important;
  font-weight: bold;
}

.el-step__head.is-finish .el-step__icon .el-step__icon-inner {
  content: "";
  font-size: 0;
}

@media (max-width: 768px) {
  .modal-dialog.modal-dialog-scrollable {
    height: 90vh;
  }
}
</style>
